import { jsonHeaders } from '#lib/helpers/fetch.js';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';
import { useAuthQuery } from '#lib/hooks/use-query.js';
import toast from 'react-hot-toast';

async function getTree(_, authHeaders) {
    const response = await fetch(`${API_URL}/p/intl/getTree`, {
        method: 'GET',
        headers: { ...jsonHeaders, ...authHeaders }
    });

    return await response.json();
}

async function setLabel(body, authHeaders) {
    const response = await fetch(`${API_URL}/p/intl/setLabel`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify({ body })
    });

    return await response.json();
}

async function setAll(body, authHeaders) {
    const response = await fetch(`${API_URL}/p/intl/setAll`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(body)
    });

    return await response.json();
}

export default function useIntl() {
    const { data, ...flags } = useAuthQuery({
        queryKey: ['tree'],
        queryFn: getTree,
        refetchOnWindowFocus: false
    });

    const save = useAuthMutation({
        mutationFn: setLabel,
        mutationKey: ['label'],
        onSuccess: (res) => {
            res.ok ? toast.success(_t.intl.save()) : toast.error(res.errorText);
        },
        onError: () => console.error('Server Error')
    });

    const saveAll = useAuthMutation({
        mutationFn: setAll,
        mutationKey: ['labels'],
        onSuccess: (res) => {
            res.ok ? toast.success(_t.intl.save()) : toast.error(res.errorText);
        },
        onError: () => console.error('Server Error')
    });

    return { data, flags, save, saveAll };
}
